import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { wmrConfigLoad } from 'portal/store/wmrConfig/actions'

export const useWmrConfigLoader = (accountId: string, projectId: string) => {
  const dispatch = useDispatch()

  useEffect(() => {
    if (accountId && projectId) {
      dispatch(wmrConfigLoad(accountId, projectId))
    }
  }, [dispatch, accountId, projectId])

  const wmrConfigState = useSelector((state: any) => {
    return state.wmrConfig
  })

  return {
    loading: wmrConfigState.loading,
    error: wmrConfigState.error,
    data: wmrConfigState.data,
    upload: wmrConfigState.upload,
    confirm: wmrConfigState.confirm,
    exportState: wmrConfigState.export
  }
}
